<template>
  <div class="main">
    <!--教师类型筛选-->
    <div class="flex selectTypeMain">
      <label 
      v-for="(filter,index) of topFilters" 
      :key="index"
      class="selectTypeItem flexItem">
      <input 
      type="checkbox" 
      :value="filter.name"
      v-model="checkedFilters">
      {{filter.name}}
      </label>
    </div>
    <!--搜索结果-->
    <div class="searchResMain">
      <!--结果状态栏-->
      <div class="searchBar flex">
        <span class="flexItem js_totalNum">{{ total }}条记录</span>
      </div>
      <!--搜索结果-->
      <div v-if="courseList.length == 0" class="searchResult">
        <div class="listNullTip">
          <img src="../../assets/icon_empty.png" />
          <span>暂无数据</span>
        </div>
      </div>
      <div v-if="courseList.length != 0" class="searchResult">
        <router-link
          v-for="(course, index) of courseList"
          :key="index"
          class="classesItem"
          :to="{path:'/coursedetail', query:{id:course.id}}"
        >
          <img :src="course.cover" />
          <div class="desc">
            <h6>{{ course.name }}</h6>
            <p>
              <span v-if="course.statusMsg == '报名中'" class="status green">{{
                course.statusMsg
              }}</span>
              <span v-if="course.statusMsg == '已结束'" class="status red">{{
                course.statusMsg
              }}</span>
              <span v-if="course.statusMsg == '报名中'" class="status blue"
                >{{ course.trainCycle }}天</span
              >
              <span class="txt"
                >{{ course.classify }} {{ course.videoTotalCount }}节课</span
              >
            </p>
            <div class="progress">
              <div class="in" :style="{ width: courseProgress(course) }"></div>
            </div>
            <p class="flex">
              <span class="txt"
                >{{ course.applyCount }}/{{ course.upperLimit }}</span
              >
              <span class="money flexItem">¥{{ course.money }}</span>
            </p>
          </div>
        </router-link>
      </div>
      <div v-if="courseList.length != 0" class="pager">
        <div class="layui-laypage">
          <button @click="firstPage" :disabled="currentPage == 1">首页</button>
          <button @click="previousPage" :disabled="currentPage == 1">上页</button>
          <button @click="nextPage" :disabled="currentPage >= pageCount">下页</button>
          <button @click="lastPage" :disabled="currentPage >= pageCount">尾页</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checkedFilters: [],
      currentPage: 1,
    };
  },
  mounted() {
    // 添加可能传入的参数
    for (const filter of this.topFilters) {
      if (
        filter.name == this.initClassify &&
        this.checkedFilters.indexOf(this.initClassify) < 0
      ) {
        this.checkedFilters.push(this.initClassify);
      }
    }
  },
  computed: {
    total() {
      return this.$store.state.courseCenterTotal;
    },
    topFilters() {
      return this.$store.state.courseCenterTopFilters;
    },
    courseList() {
      return this.$store.state.courseCenterList;
    },
    // 页面初始化时可能从外部传入的类型
    initClassify() {
      return this.$route.query.c == null ? "" : this.$route.query.c;
    },
    pageCount: {
      get() {
        if (this.total % 10 == 0) {
          return parseInt(this.total / 10);
        } else {
          return parseInt(this.total / 10) + 1;
        }
      }
    }
  },
  watch: {
    checkedFilters: {
      deep: true,
      handler() {
        this.$emit("hillockFilters", this.checkedFilters);
      },
    },
    currentPage: {
      handler() {
        this.$emit('pageChanged', this.currentPage);
      },
    },
  },
  methods: {
    courseProgress(course) {
      let current = course.applyCount;
      let total = course.upperLimit;
      let percent = parseInt((current / total) * 100);
      return percent + "%";
    },
    firstPage() {
      this.currentPage = 1;
    },
    previousPage() {
      this.currentPage -= 1;
    },
    nextPage() {
      this.currentPage += 1;
    },
    lastPage() {
      this.currentPage = this.pageCount;
    },
  },
};
</script>

<style scoped>
.main {
  position: relative;
  overflow: auto;
  background-color: white;
  min-height: 600px;
  padding-bottom: 90px;
}

.flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.flexItem {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  min-width: 0;
}

.selectTypeMain {
  height: 110px;
  background: white;
  padding-left: 30px;
  padding-right: 60px;
  padding-top: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(237, 237, 237, 1);
  overflow-x: auto;
  overflow-y: hidden;
}

.selectTypeMain .selectTypeItem {
  background-color: rgba(2, 88, 173, 0.08);
  height: 70px;
  margin-right: 20px;
  border-radius: 10px;
  border: 2px solid rgba(237, 237, 237, 1);
  padding: 15px;
  color: rgba(35, 51, 64, 1);
  font-size: 16px;
  line-height: 40px;
  position: relative;
  cursor: pointer;
}

.selectTypeMain .selectTypeItem input[type="checkbox"] {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 25px;
  right: 15px;
}

.selectTypeMain .selectTypeItem:last-child {
  margin-right: 0;
}

.selectTypeMain .selectTypeItem.active {
  border-color: rgba(2, 88, 173, 1);
}

.searchResMain {
  padding-left: 30px;
  padding-right: 60px;
}

.searchResMain .searchBar {
  height: 70px;
  align-items: center;
}

.searchResMain .searchBar .js_totalNum {
  color: rgba(35, 51, 64, 1);
  font-size: 14px;
  font-weight: 600;
}

.searchResult {
  font-size: 0;
  overflow-x: auto;
}

.searchResult .classesItem {
  margin-right: 26px;
}

.listNullTip {
  width: 100%;
  padding-top: 126px;
}

.listNullTip img {
  display: block;
  margin: 0 auto;
  width: 240px;
  margin-bottom: 9px;
}

.listNullTip span {
  display: block;
  text-align: center;
  color: #8c8c8c;
  font-size: 14px;
}

.layui-laypage {
  margin-top: 20px;
}
.layui-laypage button {
  display: inline-block;
  height: 36px;
  padding-left: 8px;
  padding-right: 8px;
  border-radius: 4px;
  background: #fff;
  border: 1px solid #d9d9d9;
  color: rgba(0, 0, 0, 0.65);
  font-size: 16px;
  line-height: 36px;
  margin-right: 10px;
}
.layui-laypage button:hover {
  color: var(--link-hover-color);
}
.layui-laypage button:disabled {
  color: lightgray;
}
</style>